"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getRunRate = (props) => {
    if (!props.ballsPerOver)
        props.ballsPerOver = 6;
    let oversT = props.oversBowled.toString();
    let val = 0;
    if (oversT.search(/\./) > -1) {
        oversT = oversT.split('.');
        if (oversT[1] === '0' || Number(oversT[1]) >= props.ballsPerOver) {
            val = Number(oversT[0]);
        }
        else {
            val = Number(oversT[0]) + Number(Number('0.' + oversT[1]) / Number('0.' + props.ballsPerOver));
        }
    }
    else {
        val = Number(oversT);
    }
    return val > 0 ? Number((props.runs / val).toFixed(2)) : 0;
};
exports.default = getRunRate;
//# sourceMappingURL=getRunRate.js.map